import React, {useContext, useEffect, useRef, useState} from 'react';
import { IonApp, IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonItem, IonList, IonSplitPane, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonSlides } from '@ionic/react';
import { IonTabs, IonTabBar, IonTabButton, IonText, IonLabel, IonFooter, IonSlide, IonImg, IonRouterOutlet } from '@ionic/react';
import { Redirect} from 'react-router-dom';

import '../../../css/layout.css';

import { ShowProductPicsModal } from './Modal_ShowProductPics'

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';



 export function ViewProductDetailDataModal (props) {



    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    let [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    let [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [employeeID, setEmployeeID] = useState(authenticatedMerchent_context.employeeID);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL] = useState(authenticatedMerchent_context.baseURL);
    
    let [productID, setProductID] = useState(props.data.productID);
    let [productSalePrice, setProductSalePrice] = useState(props.data.productSalePrice);
    let [productPicsModal, setProductPicsModal] = useState(false);
    let [viewProductDetailsData, setViewProductDetailsData] = useState([]);
    let [showProductDetails, setShowProductDetails] = useState(false);

    let [productPic1, setProductPic1] = useState(null);
    let [productPic2, setProductPic2] = useState(null);
    let [productPic3, setProductPic3] = useState(null);
    let [productPic4, setProductPic4] = useState(null);

    let [selectedFile, setSelectedFile] = useState(null);

    let [row_1, setRow_1] = useState(false);
    let [row_2, setRow_2] = useState(false);
    let [row_3, setRow_3] = useState(false);
    let [row_4, setRow_4] = useState(false);
    let [row_5, setRow_5] = useState(false);
    let [row_6, setRow_6] = useState(false);
    let [row_7, setRow_7] = useState(false);
    let [row_8, setRow_8] = useState(false);
    let [row_9, setRow_9] = useState(false);
    let [row_10, setRow_10] = useState(false);
    let [row_11, setRow_11] = useState(false);



    // let createProductAddition_type = useRef(props.data.addition_type);
    // let createProductTypeRef = useRef(props.data.itemType);
    // let createProductDescriptionRef = useRef(props.data.itemDescription);
    // let createProductPartNumRef = useRef(props.data.vendorPartNum);
    // let createProductPhoneNumberRef = useRef(props.data.vendorPartNum);
    // let createProductAddressRef = useRef(props.data.vendorAddress);
    // let createProductCityRef = useRef(props.data.vendorCity);
    // let createProductCountryRef = useRef(props.data.vendorCountry);
    // let createProductCostPerUnitRef = useRef(props.data.costPerUnit);
    // let createProductSalePriceRef = useRef(props.data.salePrice);
    // let createProductQtyInUse = useRef(props.data.qtyInUse);
    // let createProductDateCreated = useRef(props.data.dateCreated);
    // let createProductAddedBy = useRef(props.data.addedBy);


    let [createProductAddition_type, setCreateProductAddition_type] = useState(props.data.addition_type);

    let [productType, setProductType] = useState(null);
    let [productName, setProductName] = useState(null);
    let [productDescription, setProductDescription] = useState(null);
    let [productPartNum, setProductPartNum] = useState(null);
    let [productPhoneNumber, setProductPhoneNumber] = useState(null);
    let [productAddress, setProductAddress] = useState(null);
    let [productCity, setProductCity] = useState(null);
    let [productCountry, setProductCountry] = useState(null);
    let [productCostPerUnit, setProductCostPerUnit] = useState(null);
    //let [productSalePrice, setProductSalePrice] = useState(null);
    let [productQtyInUse, setProductQtyInUse] = useState(null);
    let [productDateCreated, setProductDateCreated] = useState(null);
    let [productAddedBy, setProductAddedBy] = useState(null);
    let [attachment, setAttachment] = useState(null);
    let [quantityAvailable, setQuantityAvailable] = useState(null);


function getProductDetailData() {

    const requestOptions = {
        method: 'POST',
        //credentials: 'include',
        headers: {
            'Accept': 'text/html, application/json',
            'content-type': 'application/json',
            //'cookie': 'cookie',
        },
        body: JSON.stringify({
            Tracker: '74308_retail',
            user: acctID,
            xInventoryProductID: props.data.productID,
            sessionID: sessionID,
        }),
    }

    
    fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
    .then(res => res.text())
    .then(res => {

        let rows = res.toString().split('~~~');

        for (let rownum = 0; rownum < rows.length - 1; ++rownum)
        {
            let cols = rows[rownum].split('|');

            setProductID(cols[0]);
            setProductType(cols[1]);
            setProductName(cols[2]);
            setProductDescription(cols[3]);
            setProductPartNum(cols[4]);
            setProductPhoneNumber(cols[5]);
            setProductAddress(cols[6]);
            setProductCity(cols[7]);
            setProductCountry(cols[8]);
            setProductCostPerUnit(parseFloat(cols[9]).toFixed(2));
            setProductSalePrice(parseFloat(cols[10]).toFixed(2));
            setProductPic1(cols[11]);
            setProductPic2(cols[12]);
            setProductPic3(cols[13]);
            setProductPic4(cols[14]);
            setAttachment(cols[15]);
            setQuantityAvailable(cols[16]);

            setViewProductDetailsData((prevViewProductDetailsData) => {
                return prevViewProductDetailsData.concat({
                    productID: cols[0],
                    productType: cols[1],
                    productName: cols[2],
                    productDescription: cols[3],
                    productPartNum: cols[4],
                    productPhoneNumber: cols[5],
                    productAddress: cols[6],
                    productCity: cols[7],
                    productCountry: cols[8],
                    productCostPerUnit: parseFloat(cols[9]).toFixed(2),
                    productSalePrice: parseFloat(cols[10]).toFixed(2),
                    productPic1: cols[11],
                    productPic2: cols[12],
                    productPic3: cols[13],
                    productPic4: cols[14],
                    attachment: cols[15],
                    quantityAvailable: cols[16],

                })
            });

        }
        
    })

}

function updateProduct() {

    let formData = new FormData();
    //formData.append('xProductPics', totalProductPics);
    //formData.append('xProductPics', [ProductPic1, ProductPic2, ProductPic3, ProductPic3]);
    formData.append('Tracker', '74300_update_product');
    formData.append('user', acctID);
    formData.append('merchantSchema', schema);
    formData.append('xInventoryProductID', props.data.productID);
    //formData.append('xInventoryItemID', itemID);
    formData.append('xInventoryProductType', productType);
    formData.append('xInventoryProductName', productName);
    formData.append('xInventoryProductDescription', productDescription);
    formData.append('xInventoryProductPartNum', productPartNum);
    formData.append('xInventoryProductPhoneNumber', productPhoneNumber);
    formData.append('xInventoryProductAddress', productAddress);
    formData.append('xInventoryProductCity', productCity);
    formData.append('xInventoryProductCountry', productCountry);
    formData.append('xInventoryProductCostPerUnit', productCostPerUnit);
    formData.append('xInventoryProductSalePrice', productSalePrice);
    formData.append('xProductQuantityAvailable', productQtyInUse);
    //formData.append('xSupportingDocumentation', selectedFile);
    //formData.append('xEnterAdminPassword', adminPassword);
    //formData.append('xStorefront', props.data.storefront);
    formData.append('sessionID', sessionID);
    // formData.append('xPic1', productPic1);
    // formData.append('xPic2', productPic2);
    // formData.append('xPic3', productPic3);
    // formData.append('xPic4', productPic4);


    const requestOptions = {
        enctype: 'multipart/form-data',
        method:'POST',
        //credentials: 'include',
        file: formData,
        body: formData,
        contentType: false,
        processData: false,
    }
    


    fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
    .then(res => res.text())
    .then(data => {

        alert(data);
    })
    .catch(error => {
        console.error(error);
    })

}

function closeModalHandler() {

    props.closeModal(false);
}

useEffect(() =>  {

    //alert("In produt detals modal");
    //alert(props.data.productID);

        
    getProductDetailData(); 

}, [])

            return(

                <React.Fragment>
                {props.openModal == true ?
                (
            <IonModal id='showProductDetails' isOpen={ props.openModal}>ds
                    <IonContent className='grid_content_details'>
                    <IonGrid >
                            <IonRow>
                                <IonCol size='6'><h3>Product ID</h3></IonCol>
                                <IonCol size='6'><h3>Sale Price</h3></IonCol>
                            </IonRow>
                            <IonRow >
                                <IonCol size='6'><IonText>{productID}</IonText></IonCol>
                                <IonCol size='6'><IonText>{productSalePrice}</IonText></IonCol>
                            </IonRow>
                        </IonGrid>
                    <IonGrid>
                        <IonRow>
                            <IonCol>
                                <IonSlides>
                                    <IonSlide>
                                    {viewProductDetailsData.map((detailData) =>   {
                                        return (
                                            <div style={{ height: '100%', overflowY: 'auto' }}>
                                        <IonGrid >
                                            <IonRow >
                                                <IonCol >Category</IonCol>
                                                <IonCol >Value</IonCol>
                                                <IonCol >Action</IonCol>
                                            </IonRow>
                                            <IonRow >
                                                <IonCol >Type</IonCol>
                                                <IonCol >{detailData.productType}</IonCol>
                                                <IonCol >
                                                    <IonButton > Update </IonButton>
                                                </IonCol>
                                            </IonRow>
                                            <IonRow class='gridResultBody'>
                                                <IonCol size='6' class='gridResultHeaders'>Product Images</IonCol>
                                                <IonCol size='6' class='gridResultColumns'>
                                                    <ShowProductPicsModal openModal={ productPicsModal } closeModal={() => setProductPicsModal(false)} data={{
                                                    productPic1: detailData.productPic1, 
                                                    productPic2: detailData.productPic2, 
                                                    productPic3: detailData.productPic3, 
                                                    productPic4: detailData.productPic4, 
                                                    productID: detailData.productID, 
                                                    productSalePrice: detailData.productSalePrice
                                                    }}></ShowProductPicsModal>
                                                    <IonButton class='gridResultColumnButton' onClick={() => setProductPicsModal(true)}> View </IonButton>
                                                </IonCol>
                                            </IonRow>
                                                <IonRow>
                                                    <IonCol>
                                                    <IonLabel for="ProductType">Product Type</IonLabel>
                                                    </IonCol>
                                                    <IonCol>
                                                    <select
                                                        name="productType"
                                                        id="productType"
                                                        onChange={(e) => setProductType(e.detail.value)}
                                                    >
                                                        <option value="std">Standard</option>
                                                        <option value="dlx">Deluxe</option>
                                                        <option value="exec">Executive</option>
                                                    </select>
                                                    </IonCol>
                                                </IonRow>
                                                <IonRow>
                                                    <IonCol>
                                                    <IonLabel>Product Name:</IonLabel>
                                                    </IonCol>
                                                    <IonCol>
                                                    {row_2 && (
                                                        <IonInput
                                                        type='text' 
                                                        placeholder="Enter Product Name"
                                                        onIonChange={(e) => setProductName(e.detail.value)}
                                                        ></IonInput>
                                                    )}
                                                    {!row_2 && <IonText>{productName}</IonText>}
                                                    </IonCol>
                                                    {!row_2 && (
                                                    <IonCol>
                                                        <IonButton onClick={() => setRow_2(true)}>Update</IonButton>
                                                    </IonCol>
                                                    )}
                                                    {row_2 && (
                                                    <IonCol>
                                                        <IonButton onClick={() => setRow_2(false)}>Confirm</IonButton>
                                                    </IonCol>
                                                    )}
                                                </IonRow>
                                                <IonRow>
                                                    <IonCol>
                                                    <IonLabel>Product Description:</IonLabel>
                                                    </IonCol>
                                                </IonRow>
                                                <IonRow>
                                                    <IonCol>
                                                    {row_3 && (
                                                        <textarea cols="40" rows="10"  placeholder="Enter Product Description" onChange={(e) => setProductDescription(e.target.value)} ></textarea>
                                                    )}
                                                    {!row_3 &&  <textarea cols="40" rows="10" value={productDescription}  ></textarea>}
                                                    </IonCol>
                                                    {!row_3 && (
                                                    <IonCol>
                                                        <IonButton onClick={() => setRow_3(true)}>Update</IonButton>
                                                    </IonCol>
                                                    )}
                                                    {row_3 && (
                                                    <IonCol>
                                                        <IonButton onClick={() => setRow_3(false)}>Confirm</IonButton>
                                                    </IonCol>
                                                    )}
                                                </IonRow>
                                                <IonRow>
                                                    <IonCol>
                                                    <IonLabel>Product Part Number:</IonLabel>
                                                    </IonCol>
                                                    <IonCol>
                                                    {row_4 && (
                                                        <IonInput
                                                        type='text' 
                                                        placeholder="Enter Product Part Number"
                                                        onIonChange={(e) => setProductPartNum(e.detail.value)}
                                                        ></IonInput>
                                                    )}
                                                    {!row_4 && <IonText>{productPartNum}</IonText>}
                                                    </IonCol>
                                                    {!row_4 && (
                                                    <IonCol>
                                                        <IonButton onClick={() => setRow_4(true)}>Update</IonButton>
                                                    </IonCol>
                                                    )}
                                                    {row_4 && (
                                                    <IonCol>
                                                        <IonButton onClick={() => setRow_4(false)}>Confirm</IonButton>
                                                    </IonCol>
                                                    )}
                                                </IonRow>
                                                <IonRow>
                                                    <IonCol>
                                                    <IonLabel>Product Phone Number:</IonLabel>
                                                    </IonCol>
                                                    <IonCol>
                                                    {row_5 && (
                                                        <IonInput
                                                        type='text'
                                                        placeholder="Enter Product Phone Number"
                                                        onIonChange={(e) => setProductPhoneNumber(e.detail.value)}
                                                        ></IonInput>
                                                    )}
                                                    {!row_5 && <IonText>{productPhoneNumber}</IonText>}
                                                    </IonCol>
                                                    {!row_5 && (
                                                    <IonCol>
                                                        <IonButton onClick={() => setRow_5(true)}>Update</IonButton>
                                                    </IonCol>
                                                    )}
                                                    {row_5 && (
                                                    <IonCol>
                                                        <IonButton onClick={() => setRow_5(false)}>Confirm</IonButton>
                                                    </IonCol>
                                                    )}
                                                </IonRow>
                                                <IonRow>
                                                    <IonCol>
                                                    <IonLabel>Product Address:</IonLabel>
                                                    </IonCol>
                                                    <IonCol>
                                                    {row_6 && (
                                                        <IonInput
                                                        type='text' 
                                                        placeholder="Enter Product Address"
                                                        onIonChange={(e) => setProductAddress(e.detail.value)}
                                                        ></IonInput>
                                                    )}
                                                    {!row_6 && <IonText>{productAddress}</IonText>}
                                                    </IonCol>
                                                    {!row_6 && (
                                                    <IonCol>
                                                        <IonButton onClick={() => setRow_6(true)}>Update</IonButton>
                                                    </IonCol>
                                                    )}
                                                    {row_6 && (
                                                    <IonCol>
                                                        <IonButton onClick={() => setRow_6(false)}>Confirm</IonButton>
                                                    </IonCol>
                                                    )}
                                                </IonRow>
                                                <IonRow>
                                                    <IonCol>
                                                    <IonLabel>Product City:</IonLabel>
                                                    </IonCol>
                                                    <IonCol>
                                                    {row_7 && (
                                                        <IonInput
                                                        type='text' 
                                                        placeholder="Enter Product City"
                                                        onIonChange={(e) => setProductCity(e.detail.value)}
                                                        ></IonInput>
                                                    )}
                                                    {!row_7 && <IonText>{productCity}</IonText>}
                                                    </IonCol>
                                                    {!row_7 && (
                                                    <IonCol>
                                                        <IonButton onClick={() => setRow_7(true)}>Update</IonButton>
                                                    </IonCol>
                                                    )}
                                                    {row_7 && (
                                                    <IonCol>
                                                        <IonButton onClick={() => setRow_7(false)}>Confirm</IonButton>
                                                    </IonCol>
                                                    )}
                                                </IonRow>
                                                <IonRow>
                                                    <IonCol>
                                                    <IonLabel>Product Country:</IonLabel>
                                                    </IonCol>
                                                    <IonCol>
                                                    {row_8 && (
                                                        <IonInput
                                                        type='text' 
                                                        placeholder="Enter Product Country"
                                                        onIonChange={(e) => setProductCountry(e.detail.value)}
                                                        ></IonInput>
                                                    )}
                                                    {!row_8 && <IonText>{productCountry}</IonText>}
                                                    </IonCol>
                                                    {!row_8 && (
                                                    <IonCol>
                                                        <IonButton onClick={() => setRow_8(true)}>Update</IonButton>
                                                    </IonCol>
                                                    )}
                                                    {row_8 && (
                                                    <IonCol>
                                                        <IonButton onClick={() => setRow_8(false)}>Confirm</IonButton>
                                                    </IonCol>
                                                    )}
                                                </IonRow>
                                                <IonRow>
                                                    <IonCol>
                                                    <IonLabel>Product Cost Per Unit:</IonLabel>
                                                    </IonCol>
                                                    <IonCol>
                                                    {row_9 && (
                                                        <IonInput
                                                        type='number' 
                                                        placeholder="Enter Product Cost Per Unit"
                                                        onIonChange={(e) => setProductCostPerUnit(e.detail.value)}
                                                        ></IonInput>
                                                    )}
                                                    {!row_9 && <IonText>{productCostPerUnit}</IonText>}
                                                    </IonCol>
                                                    {!row_9 && (
                                                    <IonCol>
                                                        <IonButton onClick={() => setRow_9(true)}>Update</IonButton>
                                                    </IonCol>
                                                    )}
                                                    {row_9 && (
                                                    <IonCol>
                                                        <IonButton onClick={() => setRow_9(false)}>Confirm</IonButton>
                                                    </IonCol>
                                                    )}
                                                </IonRow>
                                                <IonRow>
                                                    <IonCol>
                                                    <IonLabel>Product Sale Price:</IonLabel>
                                                    </IonCol>
                                                    <IonCol>
                                                    {row_10 && (
                                                        <IonInput
                                                        type='number' 
                                                        placeholder="Enter Product Sale Price"
                                                        onIonChange={(e) => setProductSalePrice(e.detail.value)}
                                                        ></IonInput>
                                                    )}
                                                    {!row_10 && <IonText>{productSalePrice}</IonText>}
                                                    </IonCol>
                                                    {!row_10 && (
                                                    <IonCol>
                                                        <IonButton onClick={() => setRow_10(true)}>Update</IonButton>
                                                    </IonCol>
                                                    )}
                                                    {row_10 && (
                                                    <IonCol>
                                                        <IonButton onClick={() => setRow_10(false)}>Confirm</IonButton>
                                                    </IonCol>
                                                    )}
                                                </IonRow>
                                                <IonRow>
                                                    <IonCol>
                                                    <IonLabel>Quantity Available:</IonLabel>
                                                    </IonCol>
                                                    <IonCol>
                                                    {row_11 && (
                                                        <IonInput
                                                        type='text' 
                                                        placeholder="Enter Quantity Available"
                                                        onIonChange={(e) => setProductQtyInUse(e.detail.value)}
                                                        ></IonInput>
                                                    )}
                                                    {!row_11 && <IonText>{quantityAvailable}</IonText>}
                                                    </IonCol>
                                                    {!row_11 && (
                                                    <IonCol>
                                                        <IonButton onClick={() => setRow_11(true)}>Update</IonButton>
                                                    </IonCol>
                                                    )}
                                                    {row_11 && (
                                                    <IonCol>
                                                        <IonButton onClick={() => setRow_11(false)}>Confirm</IonButton>
                                                    </IonCol>
                                                    )}
                                                </IonRow>
                                                </IonGrid>
                                            </div>
                                                )
                                            }
                                        )}
                                        </IonSlide>
                                    </IonSlides>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                        </IonContent>
                        <IonFooter class='grid_footer'>
                                <IonGrid>
                                    <IonRow>
                                        <IonCol size="6">
                                            <IonButton onClick={() => updateProduct()}> Save </IonButton>
                                        </IonCol>
                                        <IonCol size="6">
                                            <IonButton  onClick={() => closeModalHandler()}>Cancel </IonButton>
                                        </IonCol>
                                    </IonRow>
                                </IonGrid>
                        </IonFooter>
                    </IonModal>) : null}
    </React.Fragment>
            )
}   



export default ViewProductDetailDataModal;